// extracted by mini-css-extract-plugin
export default {"langButton":"language-switch-button_langButton__TTTAS"};